import React from 'react'
import { hour24ToMeridiem } from "helpers/datetime";
import moment from "moment-timezone";
import blankAvatar from 'styles/BlankAvatar.svg';

const ATHeader = ({ at, job, tz, eventTitle }) => {
  if (!job) return null;

  if (job.currentState !== "pending") {
    return (
      <div>
        <img src={at.profilePic || blankAvatar} alt={"AT"} />
        <p className="athletic-trainer-name">{at.name}</p>
      </div>
    );
  }

  const displayAppExpires = () => {
    const jobStartDate = moment(job.startTime);
    const appliedDate = moment(job.appliedDate);
    const diffBetweenStartAndApply = jobStartDate.diff(appliedDate, "minutes");
    const SEVEN_DAYS_IN_MINUTES = 7 * 24 * 60;

    if (job.currentState !== "pending") return false;

    return SEVEN_DAYS_IN_MINUTES <= diffBetweenStartAndApply;
  };

  return (
    <div className="at-profile-with-shift-details">
      <img src={at.profilePic || blankAvatar} alt={"AT"} />
      <div className="shift-details">
        <p className="athletic-trainer">{at.name}</p>
        <p>Application for {eventTitle}</p>
        <p>
          Shift:{" "}
          {`${hour24ToMeridiem(job.start)} - ${hour24ToMeridiem(job.end)} on ${moment(job.startDate).format(
            "MM/DD/YYYY"
          )}`}
        </p>
        <p>Applied on {moment.tz(job.appliedDate, tz).format("MM/DD/YYYY")} </p>
        {displayAppExpires() && (
          <p>Application Expires on {moment.tz(job.expiresAt, tz).format("MM/DD/YYYY")}</p>
        )}
      </div>
    </div>
  );
}

export default ATHeader